import axios from "axios";

const authenticate = async (data) => {
  return await axios
    .post(`${process.env.REACT_APP_API_ENDPOINT}/s1services`, {
      url: "",
      ...data,
      service: "authenticate",
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default authenticate;
